import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import PaginationComponent from "../../Pagination/Pagination";

import shape from '../../../../assets/resources/shape.png';

import { getTitle } from '../../../../helpers/admin/productHelper';
import { formatMainImage, formatProductReviews } from '../../../../helpers/shop/shopHelper';

//MUI
import {
    Box, Container, FormControl, Grid, InputLabel, MenuItem,
    Pagination, Select, Stack, Typography, useMediaQuery
} from '@mui/material';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const PromotionComponent = () => {

    const matches = useMediaQuery('(max-width: 950px)');
    const prod_match_1 = useMediaQuery('(max-width: 1535px)');
    const prod_match_2 = useMediaQuery('(max-width: 550px)');
    // productos en promoción
    const { promotionProducts } = useSelector(state => state.shop);
    const [filteredProducts, setFilteredProducts] = useState([]);

    useEffect(() => {
        setFilteredProducts(promotionProducts);
    }, [promotionProducts]);

    //Pagination
    let [page, setPage] = useState(1);
    const PER_PAGE = prod_match_2 ? 10 : prod_match_1 ? 12 : 15

    const count = Math.ceil(filteredProducts.length / PER_PAGE);
    const _DATA = PaginationComponent(filteredProducts, PER_PAGE);

    const handleChangePagination = (e, p) => {
        setPage(p);
        _DATA.jump(p);
        window.scrollTo({ top: 0 })
    };

    const myRef = useRef(null);

    const [filter, setFilter] = useState('50');

    // obtener precio menor de variantes para filtro
    const getMinPrice = (p) => {
        const prices = p.prod_variants.map(e => e.price);
        const min = Math.min(...prices);
        return min;
    };

    // obtener promedio de reseñas para filtro
    const getAverageReview = (p) => {
        return Number(p.review_summary?.average || 0);
    };

    // filtrar productos
    const onChangeFilter = ({ target }) => {
        setFilter(target.value);
        const arr = [...filteredProducts];
        switch (target.value) {
            case '10': // menor precio
                setFilteredProducts(arr.sort(function (a, b) {
                    const a_min = getMinPrice(a);
                    const b_min = getMinPrice(b);
                    return (a_min > b_min) ? 1 : ((b_min > a_min) ? -1 : 0);
                }));
                break;
            case '20': // mayor precio
                setFilteredProducts(arr.sort(function (a, b) {
                    const a_min = getMinPrice(a);
                    const b_min = getMinPrice(b);
                    return (a_min < b_min) ? 1 : ((b_min < a_min) ? -1 : 0);
                }));
                break;
            case '30': // nombre ascendente
                setFilteredProducts(arr.sort(function (a, b) {
                    return (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0);
                }));
                break;
            case '40': // nombre descendente
                setFilteredProducts(arr.sort(function (a, b) {
                    return (a.title < b.title) ? 1 : ((b.title < a.title) ? -1 : 0);
                }));
                break;
            case '50':
                setFilteredProducts(arr.sort(function (a, b) {
                    const a_prom = getAverageReview(a);
                    const b_prom = getAverageReview(b);
                    return (a_prom < b_prom) ? 1 : ((b_prom < a_prom) ? -1 : 0);
                }));
                break;
            default:
                break;
        }
    };

    return (
        <Container maxWidth='xxl' sx={{ mt: matches ? 5 : 18 }} className="last-view" ref={myRef}>
            <Typography variant='h5' sx={{ fontWeight: '600', mb: 5 }}>Todos los productos en promoción</Typography>

            {
                filteredProducts.length >= 1
                    ?
                    <>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
                            <FormControl className="order-by-shop" size="small">
                                <InputLabel>Ordenar por:</InputLabel>
                                <Select
                                    name={filter}
                                    label="Ordenar por:"
                                    defaultValue={filter}
                                    value={filter}
                                    onChange={onChangeFilter}>
                                    <MenuItem value={'10'}><i className="fa-solid fa-down-long" style={{ marginRight: '10px' }}></i>Menor precio</MenuItem>
                                    <MenuItem value={'20'}><i className="fa-solid fa-up-long" style={{ marginRight: '10px' }}></i>Mayor precio</MenuItem>
                                    <MenuItem value={'30'}><i className="fa-solid fa-up-long" style={{ marginRight: '10px' }}></i>Nombre A - Z</MenuItem>
                                    <MenuItem value={'40'}><i className="fa-solid fa-down-long" style={{ marginRight: '10px' }}></i>Nombre Z - A</MenuItem>
                                    <MenuItem value={'50'}>Rating</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <Grid container spacing={4}>
                            {
                                _DATA.currentData().map(({
                                    prod_var_id, title, variant_title, url, price,
                                    barcode, item_promotion, images, review_summary
                                }) => {
                                    const img = formatMainImage(images);
                                    const full_title = getTitle(title, variant_title);
                                    // reseñas de producto
                                    const { review_prom, review_count } = formatProductReviews(review_summary);
                                    const { promo, price: promo_price, text, fontSize, description: promotionDescription } = item_promotion;

                                    return (
                                        <Grid item xxl={2.4} xl={3} lg={4} md={6} sm={6} xs={12}
                                            key={prod_var_id} style={{ display: 'flex' }}>
                                            <Box className="shop_prod" sx={{ p: 2 }}>
                                                <Grid container rowSpacing={1} columnSpacing={3} className="product-shop">
                                                    <Grid item xl={12} lg={12} md={12} sm={12} xs={5}
                                                        sx={{ my: 'auto', textAlign: 'center' }}>
                                                        <Link to={`/tienda/producto/${url}/${barcode}`}>
                                                            <div className="product-in-promotion">
                                                                <img src={ img.id}
                                                                    width='100%' height='235px' style={{ objectFit: 'contain' }}
                                                                    className="shop-product" alt={ img.alt }
                                                                />
                                                                {
                                                                    promo !== '' &&
                                                                        <div className="shop_top-image" title={promotionDescription}>
                                                                            <img src={shape} alt={shape} width='75'
                                                                                style={{ pointerEvents: 'none' }}
                                                                            />
                                                                            <div className="shop_centered_image">
                                                                                <Typography sx={{ color: '#fff', fontSize, fontWeight: 'bold' }}>
                                                                                    { text }
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                }
                                                            </div>
                                                        </Link>
                                                    </Grid>

                                                    <Grid item xl={12} lg={12} md={12} sm={12} xs={7} sx={{ my: 'auto' }}>
                                                        <Box sx={{ textAlign: { xs: 'flex-start', sm: 'center', md: 'center' } }}>
                                                            <Link to={`/tienda/producto/${url}/${barcode}`} style={{ textDecoration: 'none', color: '#000' }}
                                                                className='product_name'>
                                                                <Typography
                                                                    variant="body1"
                                                                    component="div"
                                                                    sx={{ fontWeight: '600' }}
                                                                >
                                                                    { full_title }
                                                                </Typography>
                                                            </Link>
                                                        </Box>

                                                        <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'center', md: 'center' }, mt: 1 }}>
                                                            <div className="ratings-shop">
                                                                {
                                                                    review_count > 0 ?
                                                                        Array.from(Array(review_prom), (e, j) => {
                                                                            return <i className="fas fa-star"
                                                                                style={{
                                                                                    color: '#FFA41C',
                                                                                    stroke: "#FFA41C",
                                                                                    strokeWidth: 0.2
                                                                                }}
                                                                                key={j}></i>
                                                                        })
                                                                        :
                                                                        <>
                                                                            <i className="far fa-star"></i>
                                                                            <i className="far fa-star"></i>
                                                                            <i className="far fa-star"></i>
                                                                            <i className="far fa-star"></i>
                                                                            <i className="far fa-star"></i>
                                                                        </>
                                                                }
                                                            </div>
                                                        </Box>

                                                        <Box sx={{
                                                            display: 'flex', mt: 1,
                                                            justifyContent: { xs: 'flex-start', sm: 'center', md: 'center' }
                                                        }}>
                                                            {
                                                                ['DescuentoProducto', 'DescuentoMarca'].includes(promo) ?
                                                                    <Stack
                                                                        direction="row"
                                                                        justifyContent="flex-start"
                                                                        alignItems="baseline"
                                                                        spacing={1}>
                                                                        <Typography variant="h6"
                                                                            sx={{ fontWeight: '600', color: '#000', textDecoration: 'line-through' }}>
                                                                            ${price}
                                                                        </Typography>
                                                                        <Typography variant="h6"
                                                                            sx={{ fontWeight: '600', color: '#F90606' }}>
                                                                            ${ promo_price }
                                                                        </Typography>
                                                                    </Stack>
                                                                :
                                                                    <Typography variant="h6"
                                                                        sx={{ fontWeight: '600', color: '#F90606' }}>
                                                                        ${price}
                                                                    </Typography>
                                                            }
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>

                        <Box display='flex' mt={5} justifyContent='flex-end'>
                            <Pagination
                                color="primary"
                                count={count}
                                page={page}
                                onChange={handleChangePagination}
                            />
                        </Box>
                    </>
                    :
                    <Box textAlign='center'>
                        <ManageSearchIcon sx={{ fontSize: '40px' }} />
                        <Typography variant='h5'>¡Lo sentimos! Actualmente no contamos con productos en promoción.</Typography>
                        <Typography>Te invitamos a seguir visitando nuestro sitio web para futuras ofertas y descuentos.</Typography>
                    </Box>
            }
        </Container>
    )
}

export default PromotionComponent
